/**
 * Runtime-конфиг: в Docker-контейнере значения берутся из window.__RUNTIME_CONFIG__
 * (генерируется entrypoint.sh при старте контейнера).
 * При локальной разработке (npm start) используется fallback на process.env из .env файла.
 */
const runtimeConfig = window.__RUNTIME_CONFIG__;

export const API_URL = runtimeConfig?.API_URL ?? process.env.REACT_APP_API_URL;
export const API_URL_WITH_API = `${API_URL}api/`;
const identityApiUrl =
  runtimeConfig?.IDENTITY_API_URL ?? process.env.REACT_APP_IDENTITY_API_URL;
export const IDENTITY_API_URL = identityApiUrl
  ? `${identityApiUrl.trim().replace(/\/+$/, '')}/`
  : identityApiUrl;
export const IDENTITY_API_URL_WITH_API = `${IDENTITY_API_URL}api/`;
export const API_LOADER_URL =
  runtimeConfig?.API_LOADER_URL ?? process.env.REACT_APP_API_LOADER_URL;
export const API_LOADER_URL_WITH_API = `${API_LOADER_URL}api/`;
export const API_ANALYTICS_URL =
  runtimeConfig?.API_ANALYTICS_URL ?? process.env.REACT_APP_API_ANALYTICS_URL;
